import { render, staticRenderFns } from "./investmentreturns.vue?vue&type=template&id=65f43884"
import script from "./investmentreturns.vue?vue&type=script&lang=js"
export * from "./investmentreturns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports